import styled from 'styled-components'

export const InvoiceExportTableWrapper = styled.div`
  padding-top: 15px;
  background: ${props => props.theme.colors.white};
`



// WEBPACK FOOTER //
// ./src/Components/Settings/InvoiceExport/InvoiceTableWrapper/index.js